module.exports = __webpack_public_path__ + "img/9blue.2c3752ac.png";